import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "48",
  height: "48",
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#clip0_6849_141640)" }, [
      _createElementVNode("path", {
        d: "M47.526 2.15C47.234 1.968 46.862 1.948 46.554 2.106L38.764 6H31C30.704 6 30.422 6.132 30.234 6.36L20.532 18H6V1C6 0.448 5.552 0 5 0C4.448 0 4 0.448 4 1V40.998V41.004V42H1C0.448 42 0 42.448 0 43C0 43.552 0.448 44 1 44H4V47C4 47.552 4.448 48 5 48C5.552 48 6 47.552 6 47V44H47C47.552 44 48 43.552 48 43V3C48 2.654 47.82 2.332 47.526 2.15ZM46 42H6V41.412L13.306 34.106L20.758 35.968C21.064 36.046 21.382 35.972 21.626 35.78L31.126 28.18L38.554 31.894C38.834 32.034 39.166 32.034 39.448 31.894L46 28.618V42ZM46 26.382L39 29.882L31.448 26.106C31.096 25.934 30.682 25.976 30.376 26.22L20.762 33.912L13.242 32.032C12.9 31.942 12.54 32.046 12.292 32.294L6 38.586V31.618L13.236 28H21C21.266 28 21.52 27.894 21.708 27.706L31.198 18.216L38.554 21.894C38.892 22.062 39.298 22.028 39.6 21.8L46 17V26.382ZM46 14.5L38.896 19.828L31.448 16.104C31.062 15.912 30.598 15.988 30.294 16.292L20.586 26H13C12.846 26 12.692 26.036 12.554 26.106L6 29.382V20H21C21.296 20 21.578 19.868 21.766 19.64L31.468 8H39C39.154 8 39.308 7.964 39.448 7.894L46 4.618V14.5Z",
        fill: "black"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "clip0_6849_141640" }, [
        _createElementVNode("rect", {
          width: "48",
          height: "48",
          fill: "white"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }